import React from "react";
import { useSelector } from "react-redux";
import Loading from "../Loading/Loading";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Host tools (event dashboard, check-in, payouts). One InstaPass account: any
 * signed-in person may open them — every server endpoint behind these pages
 * only returns the caller's own events, so a new host simply sees an empty
 * dashboard until they publish. Signed-out visitors go to login and come back.
 */
const OrganizerRoute = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const isAuthanticated = useSelector((state) => state.user.isAuthantication);
  const token = localStorage.getItem("instapass_user_token");
  const location = useLocation();
  const next = encodeURIComponent(location.pathname + location.search);

  if (!token) return <Navigate replace to={`/login?next=${next}`} />;
  if (Object.keys(user || {}).length === 0) {
    return (
      <div className="w-full flex justify-center place-items-center">
        <Loading />
      </div>
    );
  }
  if (user?.email && isAuthanticated === true) return <>{children}</>;
  return <Navigate replace to={`/login?next=${next}`} />;
};

export default OrganizerRoute;
